/**
 * Typed error for billing API failures.
 *
 * Extends `Error` with an optional `code` field so callers can branch on
 * the backend error code without losing it (a plain `new Error(message)`
 * throw discards the code).
 *
 * Usage:
 *   throw new BillingApiError(response.error.message, response.error.code);
 *
 * Catch:
 *   if (error instanceof BillingApiError && error.code === 'SUPPORT_SEAT_OWNER_CONFIRM_REQUIRED') { … }
 */
export class BillingApiError extends Error {
  readonly code: string | undefined;

  constructor(message: string, code?: string) {
    super(message);
    this.name = 'BillingApiError';
    this.code = code;
  }
}
